const members = [
	{
		id: 1,
		name: "Hung Do",
		position: "Developer",
		src: "Hung.jpeg",
	},
	{
		id: 2,
		name: "Minh Pham",
		position: "Developer",
		src: "Minh.jpeg",
	},
	{
		id: 3,
		name: "Qui Huynh",
		position: "Developer",
		src: "Qui.png",
	},
	{
		id: 4,
		name: "Tan Nguyen",
		position: "Developer",
		src: "Tan.jpeg",
	},
	{
		id: 5,
		name: "Bao Ho",
		position: "Developer",
		src: "Bao.jpeg",
	},
];

export default members;
